import React from "react";
import { Card, CardBody, Progress } from "reactstrap";
import moment from "moment";
import NotificationSystem from "react-notification-system";
//react-redux comm
import { connect } from "react-redux";
import { store } from "../../_helpers";
import SearchPanel from "./unbilled-panel";
import PaginatedResult from "./record";

// styling
import "./style.css";

// Actions
import { commonActions, apiActions, alertActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { appHelpers } from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import { commonService } from "../../_services";

let activeUser = appHelpers.getActiveUser();
const DateTypes = [
  { label: "Invoice Date", value: 202, cat: "DateType" },
  { label: "Aggregate Date", value: 101, cat: "DateType" },
  // { label: "Payment Date", value: 302, cat: "DateType" }
];

const Status = [
  { label: "Not Processed", value: false, cat: "Status" },
  { label: "Sent/AutoNibbs", value: true, cat: "Status" }
];

const PaymentStatus = [
  { label: "Fully Paid", value: 1, cat: "PaymentStatus" },
  { label: "Unpaid", value: 2, cat: "PaymentStatus" }
];

const ViewHeader = () => (
  <div className="view-header d-flex align-items-center">
    <header className="text-white">
      <h1 className="h5 title text-uppercase">Unbilled Passenger</h1>
      {/* <p className="mb-0 subtitle text-nowrap">Statement of TSC</p> */}
    </header>
  </div>
);
const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class UnbilledPassengers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeUser: activeUser,
      airlineName: null,
      startDate: new Date(),
      endDate: new Date(),
      url: `${appConstants.PAS_URL}/api/Aggregate/GetAggregateNewPassengers`,
      excelUrl: `${
        appConstants.PAS_URL
      }/api/Aggregate/DownloadStatementOfTscReport?DownloadTypeId=1&AirlineName=BA`,
      catOptions: [],
      searchOptions: [],
      //searchArray: [{ label: 'Flight Date', value: 1, cat: 'DateType' }],
      searchArray: [{ label: "Invoice Date", value: 202, cat: "DateType" }],
      searchLabelKey: "",
      searchValueKey: "",
      status: Status,
      dateTypes: DateTypes,
      paymentStatus: PaymentStatus,
      airlines: [],
      selectValue: { label: "Date Type", value: "DateType" },
      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [],
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux
      //Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        dismissible: true
      },
      records: false,
      pdfRecords: null,
      excelRecords: null,
      contentErrorText: false,
      passengerDetails: false,
      pageSize: 10,
      currentPage: 0,
      totalFlightCounts: 1,
      selectCategories: []
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentWillMount() {
    this.setCategories();
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    //    Fetch Airlines
    const reduxState = store.getState();
    if (reduxState.airlinesCarriers) {
      const localAirlines = reduxState.airlinesCarriers.Results.filter(
        item => item.IsLocal
      );
      this.setState({ airlines: this.formatAirlines(localAirlines) });
    } else {
      this.fetchAirlines();
    }
    // this.setState({activeUser: appHelpers.getActiveUser()});

    //Get today's records results
    this.handleCatChange({ label: "Date Type", value: "DateType" });
    // this.search();
  }

  componentDidUpdate(prevProps, prevState) {
    const { clickBD } = this.state;
    if (clickBD) {
      // debugger;
      this.search(1);
      this.setState({ clickBD: false });
    }
  }

  setCategories = () => {
    const activeUser = appHelpers.getActiveUser();
    let cat;
    if (activeUser.AirlineCode != null) {
      cat = [
        { label: "Date Type", value: "DateType" },
        { label: "Status", value: "Status" },
        // { label: "Payment Status", value: "PaymentStatus" }
      ];
    } else {
      cat = [
        { label: "Airline", value: "AirlineId" },
        { label: "Date Type", value: "DateType" },
        { label: "Status", value: "Status" },
        // { label: "Payment Status", value: "PaymentStatus" }
      ];
    }
    this.setState({ catOptions: cat });
  };
  //update selected category
  updateCatValue = newValue => {
    this.setState({
      selectValue: newValue
    });
    this.handleCatChange(newValue);
  };

  //populate the multi search options with appropriate category options
  handleCatChange = option => {
    if (option) {
      // incase all category options are remove
      switch (option.value) {
        case "AirlineCode":
          return this.setState({
            searchOptions: this.state.airlines,
            searchLabelKey: "label",
            searchValueKey: "value"
          });
        case "AirlineId":
          return this.setState({
            searchOptions: this.state.airlines,
            searchLabelKey: "label",
            searchValueKey: "value"
          });
        case "DateType":
          return this.setState({
            searchOptions: this.state.dateTypes,
            searchLabelKey: "label",
            searchValueKey: "value"
          });
        case "Status":
          return this.setState({
            searchOptions: this.state.status,
            searchLabelKey: "label",
            searchValueKey: "value"
          });
        case "PaymentStatus":
          return this.setState({
            searchOptions: this.state.paymentStatus,
            searchLabelKey: "label",
            searchValueKey: "value"
          });
        default:
          return this.state;
      }
    }
    return this.setState({ searchOptions: [], searchArray: [] });
  };

  // remove option if option in that category is already selected
  switchOptionsPerCategory = (currentArray, newArray, category) => {
    const { selectValue } = this.state;
    let currentCat = category ? category : selectValue;
    let optionToReplace = currentArray.filter(
      option => option.cat === currentCat.value
    )[0];
    if (optionToReplace) {
      return newArray.filter(option => option.label !== optionToReplace.label);
    } else {
      return newArray;
    }
  };

  //update selected options categories
  handleSelectChange = (newValue, category) => {
    let currentArray = this.state.searchArray;
    //debugger;
    let newArray =
      currentArray.length > 0
        ? this.switchOptionsPerCategory(
            this.state.searchArray,
            newValue,
            category
          )
        : newValue;
    this.setState({ searchArray: newArray });
  };

  fetchAirlines = () => {
    const { dispatch } = this.props;
    this.setState({ contentError: false });
    dispatch(apiActions.startFullPageRequest());

    dispatch(commonActions.getAirlinesCarriers())
      .then(() => {
        const { airlinesCarriers } = this.props;
        const localAirlines = airlinesCarriers.Results.filter(
          item => item.IsLocal
        );
        this.setState({ airlines: this.formatAirlines(localAirlines) });
        //this.formatAirlines(res.data.Results);
        dispatch(apiActions.endRequest());
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  formatAirlines = res => {
    let data = [];

    for (let item of res) {
      item["cat"] = "AirlineId";
      item["label"] = `${item.Name} (${item.Code})`;
      item["value"] = item.Id;
      data.push(item);
    }

    return data;
  };

  converter = item => {
    const { airlinesCarriers } = this.props;
    const filteredAirline = airlinesCarriers.Results.filter(airline => {
      return airline.Id === item;
    });
    return filteredAirline[0].Name;
  };
  formatSearchParameters = res => {
    const activeUser = appHelpers.getActiveUser();
    if (res.length > 0) {
      let searchParameters = {};
      res.map(parameter => (searchParameters[parameter.cat] = parameter.value));
      /*Cater for Airline Users */
      if (activeUser.AirlineCode != null) {
        searchParameters.AirlineId = activeUser.AirlineId;
      }
      return searchParameters;
    }
    return {};
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  search = pageNumber => {
    const { dispatch } = this.props;
    const { searchArray, pageSize, startDate, endDate } = this.state;

    // searchArray: [{ label: 'Invoice Date', value: 202, cat: 'DateType' }],
    const hasdateType = searchArray.find(obj => obj.cat === "DateType");
    !hasdateType
      ? this.setState({ contentErrorText: "Select a Date Type" })
      : this.setState({ contentErrorText: false });

    this.setState({ contentError: false });
    if (pageNumber === undefined) {
      dispatch(apiActions.startFullPageRequest());
      pageNumber = 1;
    } else {
      dispatch(apiActions.startRequest());
    }

    let fromPage = pageSize * (pageNumber - 1);

    // if((pageNumber - 1) > 0) {
    //     fromPage = 1;
    // }
    let searchParams = this.formatSearchParameters(searchArray);

    let payload = {
    //   PageSize: pageSize,
    //   From: fromPage,
        ...searchParams,
        StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
        EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59"
    };
    let url = this.state.url;
    appHelpers
      .postRequest(url, payload, {})
      .then(res => {
        this.setState({
          records: res.data,
          currentPage: pageNumber
        });
        dispatch(apiActions.endRequest());
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        //dispatch(alertActions.error(errorMessage));
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        dispatch(apiActions.endRequest());
        this.setState({ contentError: errorMessage });
      });
  };

  downloadPdfAndExcel = downloadType => {
    const { dispatch } = this.props;
    const { searchArray, startDate, endDate } = this.state;
    let searchParams = this.formatSearchParameters(searchArray);
    const payload__ = {
      PageSize: 100,
      From: 1,
      Parameter: {
        ...searchParams,
        StartDate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
        EndDate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59"
      }
    };

    commonService.downloadPdfAndExcel(payload__, downloadType).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        let response = res.response.data.File;

        window.open(response, "_blank");
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });

    dispatch(apiActions.startRequest());
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  render() {
    const {
      contentErrorText,
      catOptions,
      selectValue,
      searchOptions,
      searchLabelKey,
      searchValueKey,
      searchArray,
      contentError,
      currentPage,
      pageSize,
      records
    } = this.state;
    const { requesting, pageRequesting } = this.props;

    return (
      <div className="view">
        <ViewHeader />
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                striped
                animated
                color="success"
                value={100}
                className="mb-2"
              />
            )}
            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}

            {!contentError && !pageRequesting && (
              <CardBody>
                <h6 className="mb-4 text-uppercase">Search Panel</h6>
                <SearchPanel
                  contentErrorText={contentErrorText}
                  categories={catOptions}
                  selectedCat={selectValue}
                  multiOptions={searchOptions}
                  multiLabelKey={searchLabelKey}
                  multiValueKey={searchValueKey}
                  multiArray={searchArray}
                  onCatValueChange={this.updateCatValue}
                  onMultiValueChange={this.handleSelectChange}
                  onSearch={this.search}
                  startDateChange={startDate => this.setState({ startDate })}
                  endDateChange={endDate => this.setState({ endDate })}
                />

              
                <CardBody>
                  {!pageRequesting && records && (
                    <div>
                      <PaginatedResult
                        downloadFile={this.downloadPdfAndExcel}
                        recordResults={records}
                        currentPage={currentPage}
                        navigate={this.search}
                        pageSize={pageSize}
                        totalCount={records.TotalCount}
                        showrecord={this.showrecord}
                        converter={this.converter}
                      />
                    </div>
                  )}
                  {!pageRequesting && !records && (
                    <PageEmptyContent message="No record match your search!" />
                  )}
                </CardBody>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    airlinesCarriers: state.airlinesCarriers,
    requesting: state.api.requesting,
    pageRequesting: state.api.pageRequesting
  };
}

export default connect(mapStateToProps)(UnbilledPassengers);



// WEBPACK FOOTER //
// ./src/views/unbillled-passengers/index.js